module.exports = __webpack_public_path__ + "static/media/Shock Absorbers.8b7ccb53.webp";